(function(){
  var SYNONYMS = {
    'chango':'shango','chang':'shango','xango':'shango',
    'elegwa':'elegua','elegba':'elegua','eshu':'elegua',
    'eleggua':'elegua','eleggua':'elegua',
    'yemaia':'yemaya','yemaja':'yemaya','iemanja':'yemaya',
    'ochun':'oshun','oxun':'oshun',
    'oggun':'ogun','ogum':'ogun',
    'orula':'orunmila','orunla':'orunmila',
    'babalu':'babalu aye',
    'collar':'eleke','collares':'elekes','necklace':'eleke',
    'bead':'cuentas','beads':'cuentas',
    'candle':'vela','candles':'velas',
    'herb':'ewe','herbs':'ewe','plant':'ewe',
    'crown':'corona','crowns':'coronas',
    'doll':'muneca','dolls':'munecas',
    'statue':'estatua','book':'libro','soap':'jabon','bath':'bano'
  };

  function normalize(q){
    var l=q.toLowerCase().trim();
    // Check exact match first
    if(SYNONYMS[l]) return SYNONYMS[l];
    // Check if any synonym key is contained in query
    var keys=Object.keys(SYNONYMS);
    for(var i=0;i<keys.length;i++){
      if(l.indexOf(keys[i])!==-1) return SYNONYMS[keys[i]];
    }
    return l;
  }

  function formatMoney(val){
    if(val===null||val===undefined) return null;
    var num=parseFloat(val);
    if(isNaN(num)||num===0) return null;
    if(num>1000) num=num/100;
    return '$'+num.toFixed(2).replace(/\.00$/,'');
  }

  function getImg(p){
    if(!p.featured_image) return null;
    if(typeof p.featured_image==='string'&&p.featured_image.length>0) return p.featured_image;
    if(p.featured_image&&p.featured_image.url) return p.featured_image.url;
    if(p.featured_image&&p.featured_image.src) return p.featured_image.src;
    return null;
  }

  function hasValidPrice(p){
    var val=parseFloat(p.price_min||p.price||0);
    return val>0;
  }

  function renderResults(products,query,container,formEl){
    container.innerHTML='';
    var valid=products.filter(hasValidPrice);
    if(!valid.length){
      container.innerHTML='<div class="nelstar-search-empty">No results for "'+query+'"</div>';
      container.classList.add('active');
      return;
    }
    var frag=document.createDocumentFragment();
    valid.slice(0,6).forEach(function(p){
      var a=document.createElement('a');
      a.className='nelstar-search-item';
      a.href=p.url;
      var imgUrl=getImg(p);
      var imgHtml=imgUrl
        ?'<img class="nelstar-search-img" src="'+imgUrl+'" alt="" loading="lazy">'
        :'<div class="nelstar-search-img-placeholder">&#127807;</div>';
      var priceVal=p.price_min||p.price;
      var price=formatMoney(priceVal);
      var compareVal=p.compare_at_price_min||p.compare_at_price;
      var compare=compareVal&&parseFloat(compareVal)>parseFloat(priceVal)
        ?'<s style="color:#999;font-size:11px;margin-left:4px;">'+formatMoney(compareVal)+'</s>':'';
      a.innerHTML=imgHtml+'<div class="nelstar-search-info"><div class="nelstar-search-title">'+p.title+'</div>'+(price?'<div class="nelstar-search-price">'+price+compare+'</div>':'')+'</div>';
      frag.appendChild(a);
    });
    var footer=document.createElement('div');
    footer.className='nelstar-search-footer';
    footer.textContent='See all results for "'+query+'" \u2192';
    footer.addEventListener('click',function(){
      var input=formEl.querySelector('input[name="q"]');
      if(input) input.value=query;
      formEl.submit();
    });
    frag.appendChild(footer);
    container.appendChild(frag);
    container.classList.add('active');
  }

  var cache={},timer;

  function fetchAndRender(sq,query,container,formEl){
    var key=sq.toLowerCase();
    if(cache[key]){
      renderResults(cache[key],query,container,formEl);
      return;
    }
    container.innerHTML='<div class="nelstar-search-loading">Searching...</div>';
    container.classList.add('active');
    fetch('/search/suggest.json?q='+encodeURIComponent(sq)+'&resources[type]=product&resources[limit]=10&resources[options][fields]=title,product_type,variants.title,tag')
      .then(function(r){return r.json();})
      .then(function(data){
        var products=(data.resources&&data.resources.results&&data.resources.results.products)||[];
        cache[key]=products;
        renderResults(products,query,container,formEl);
      })
      .catch(function(){container.classList.remove('active');});
  }

  function doSearch(query,container,formEl){
    var norm=normalize(query);
    // Always search with normalized term for better results
    fetchAndRender(norm,query,container,formEl);
    // If normalized is different, also try original query and merge
    if(norm!==query.toLowerCase()){
      var origKey=query.toLowerCase();
      if(!cache[origKey]){
        fetch('/search/suggest.json?q='+encodeURIComponent(query)+'&resources[type]=product&resources[limit]=5')
          .then(function(r){return r.json();})
          .then(function(data){
            var extra=(data.resources&&data.resources.results&&data.resources.results.products)||[];
            cache[origKey]=extra;
            // Merge with normalized results if we have them
            if(cache[norm]){
              var merged=cache[norm].slice();
              extra.forEach(function(p){
                if(!merged.some(function(m){return m.id===p.id;})) merged.push(p);
              });
              renderResults(merged,query,container,formEl);
            }
          })
          .catch(function(){});
      }
    }
  }

  function initSearch(inputId,resultsId,formId){
    var input=document.getElementById(inputId);
    var results=document.getElementById(resultsId);
    var form=document.getElementById(formId);
    if(!input||!results||!form) return;
    input.addEventListener('input',function(){
      var q=input.value.trim();
      clearTimeout(timer);
      if(q.length<2){results.classList.remove('active');results.innerHTML='';return;}
      timer=setTimeout(function(){doSearch(q,results,form);},300);
    });
    input.addEventListener('keydown',function(e){
      if(e.key==='Escape'){results.classList.remove('active');results.innerHTML='';input.blur();}
    });
    document.addEventListener('click',function(e){
      if(!input.contains(e.target)&&!results.contains(e.target))results.classList.remove('active');
    });
  }

  document.addEventListener('DOMContentLoaded',function(){
    initSearch('SiteNavSearch','SiteSearchResults','SiteSearchForm');
    initSearch('DrawerSearchInput','DrawerSearchResults','DrawerSearchForm');
  });
})();